// =============================================================================
// FIRESTORE CONFIGURATION
// =============================================================================
// This configuration provides Firebase services for the public website
// including Firestore, Functions, and Storage

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// Check if Firebase is configured
const requiredEnvVars = {
  VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
  VITE_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  VITE_FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  VITE_FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  VITE_FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID,
};

const missingVars = Object.entries(requiredEnvVars)
  .filter(([_, value]) => !value)
  .map(([key]) => key);

export const isFirebaseConfigured = missingVars.length === 0;

// Initialize Firebase only if configured - NO emulator connections
let app: any = null;
let _firestore: any = null;
let _functions: any = null;
let _storage: any = null;

if (isFirebaseConfigured) {
  const firebaseConfig = {
    apiKey: requiredEnvVars.VITE_FIREBASE_API_KEY!,
    authDomain: requiredEnvVars.VITE_FIREBASE_AUTH_DOMAIN!,
    projectId: requiredEnvVars.VITE_FIREBASE_PROJECT_ID!,
    storageBucket: requiredEnvVars.VITE_FIREBASE_STORAGE_BUCKET!,
    messagingSenderId: requiredEnvVars.VITE_FIREBASE_MESSAGING_SENDER_ID!,
    appId: requiredEnvVars.VITE_FIREBASE_APP_ID!,
  };
  
  app = initializeApp(firebaseConfig);
  _firestore = getFirestore(app);
  _functions = getFunctions(app);
  _storage = getStorage(app);
}

export const firestore = _firestore;
export const functions = _functions;
export const storage = _storage;

// Note: This configuration provides Firebase services for public website functionality
// including availability checking, newsletter subscriptions, and contact forms
